

















































import { defineClassComponent } from '@/hooks'

function addQueryToHash(_url: string, _query: Record<string, any>): string {
  const url = new URL(_url)
  // 必定以 # 开头
  const hash = url.hash || '#'
  const [path = '', queryString = ''] = hash.split('?')
  const query = new URLSearchParams(queryString)
  Object.keys(_query).forEach(key => {
    if (_query[key] == null) {
      query.delete(key)
    } else {
      query.set(key, _query[key])
    }
  })
  url.hash = `${path}?${query.toString()}`
  return url.toString()
}

export default defineClassComponent(
  () =>
    class {
      appid = 'wxefde1bebca7c0aa2'

      extInfo = `targetUrl=${addQueryToHash(location.href, {
        isFull: true,
        isLogin: true,
        isAuth: true,
      })}`

      downloadUrl = 'https://h5gateway.gogpay.cn/appRS/index'

      downloadApp = () => {
        location.href = this.downloadUrl
      }
    },
)
